import React from 'react'

const RemittancePage = () => {
    return (
        <div>RemittancePage</div>
    )
}

export default RemittancePage